import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-reject-request',
  templateUrl: './reject-request.component.html',
  styleUrls: ['./reject-request.component.scss'],
})
export class RejectRequestComponent implements OnInit {

  @Input() headerMessage:string;
  @Input() message:string;
  constructor(
    private modalCtl: ModalController
  ) { 
  }

  ngOnInit() {}

  dismiss(){
    this.modalCtl.dismiss();
  }

  confirm(){
    let obj = {
      isConfirm:true
    }
    this.modalCtl.dismiss(obj);
  }
}
